import type { Cotizacion, EstadoTrabajo, RegistroTiempo, Trabajo, TrabajoProgramado } from '@laser/core';
import { duracion } from './formato';

export const cotizacionVigente = (t: Pick<Trabajo, 'cotizacionFinal' | 'cotizacionOriginal'>): Cotizacion => t.cotizacionFinal ?? t.cotizacionOriginal;

/** Lo que se le cobra al cliente: precio manual, luego recotización, luego original. */
export const totalACobrar = (t: Pick<Trabajo, 'precioFinalCentavos' | 'cotizacionFinal' | 'cotizacionOriginal'>) =>
  t.precioFinalCentavos ?? cotizacionVigente(t).totalCentavos;

/** Máquina asignada o, si no hay, la que eligió la cotización. */
export const maquinaDeTrabajo = (t: Pick<Trabajo, 'maquinaAsignadaId' | 'cotizacionFinal' | 'cotizacionOriginal'>) =>
  t.maquinaAsignadaId ?? cotizacionVigente(t).maquinaId;

export const minutosEstimados = (t: Pick<Trabajo, 'cotizacionFinal' | 'cotizacionOriginal'>) => cotizacionVigente(t).tiempo.totalS / 60;

export function minutosRegistrados(registros: RegistroTiempo[], ahora = Date.now()): number {
  return registros.reduce((s, r) => s + Math.max(0, (r.fin ? Date.parse(r.fin) : ahora) - Date.parse(r.inicio)) / 60_000, 0);
}

const SIN_PENDIENTE: EstadoTrabajo[] = ['listo', 'entregado', 'cancelado'];

export interface Atraso { tipo: 'vencido' | 'tarde'; texto: string; titulo: string }

/**
 * - vencido: la fecha compromiso ya pasó y el trabajo no está listo.
 * - tarde: el programa calcula que terminará después del compromiso.
 */
export function atrasoDe(t: Pick<Trabajo, 'estado' | 'fechaCompromiso'>, programado: TrabajoProgramado | undefined, ahora = Date.now()): Atraso | null {
  if (SIN_PENDIENTE.includes(t.estado)) return null;
  const compromiso = Date.parse(t.fechaCompromiso);
  if (compromiso < ahora) {
    return { tipo: 'vencido', texto: 'Vencido', titulo: `El compromiso venció hace ${duracion((ahora - compromiso) / 1000)}` };
  }
  if (programado?.tarde) {
    return { tipo: 'tarde', texto: `Tarde ${duracion(-programado.holguraMin * 60)}`, titulo: 'Según el programa terminará después de la fecha compromiso' };
  }
  return null;
}

export const holguraTexto = (min: number) => (min < 0 ? `${duracion(-min * 60)} tarde` : `holgura ${duracion(min * 60)}`);
